<template>
  <div class="deal-calculator">
    <div class="calculator-header">
      <h3 class="title">{{ title }}</h3>
      <div class="actions">
        <icon
          iconName="pencil"
          small
          class="mr2"
          @click="handleClickEditIcon"
        />
        <input
          type="number"
          inputmode="decimal"
          v-if="isEditing"
          :value="value"
          @input="handleChangeValue"
          @blur="isEditing=false"
          @keyup.enter="isEditing=false"
          v-focus
          ref="inputRef"
        />
        <div class="editable-text" v-else @click="isEditing = true">
          {{computedValue}}
        </div>
      </div>
    </div>

    <p class="calculator-description">
      {{ description }}
    </p>

    <vue-slider
      :value="valueSlider"
      @change="val => $emit('input', val)"
      :min="min"
      :max="max"
      :interval="step"
      adsorb
      silent
    />
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';

export default {
  components: {
    VueSlider,
  },

  props: {
    title: { type: String },
    description: { type: String },
    value: { type: Number },
    min: { type: Number },
    max: { type: Number },
    step: { type: Number },
    canHigherMax: { type: Boolean },
    prefix: { type: String },
    suffix: { type: String },
  },

  data() {
    return {
      isEditing: false,
    };
  },

  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },

  methods: {
    handleChangeValue(event) {
      let _value = +event.target.value;
      if (_value < this.min) {
        _value = this.min;
      }

      if (!this.canHigherMax && _value > this.max) {
        _value = this.max;
        this.$forceUpdate();
      }

      this.$emit('input', _value);
    },
    handleClickEditIcon() {
      this.isEditing = true;
      this.$refs.inputRef && this.$refs.inputRef.focus();
    },
  },

  computed: {
    valueSlider() {
      return Math.min(this.value, this.max);
    },
    computedValue() {
      return `${this.prefix || ''}${this.value}${this.suffix || ''}`;
    },
  },
};
</script>

<style lang="scss">
.deal-calculator {
  margin: 16px 4px 32px 4px;

  .calculator-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 0;
    }

    .actions {
      display: flex;
      align-items: center;
      .editable-text {
        width: 50px;
        padding: 8px;
        font-weight: bold;
        color: white;
        font-size: 14px;
        text-align: center;
        background-color: $color_purple;
        border-radius: 8px;
      }
      input[type=number] {
        width: 66px;
        height: 33px;
        box-sizing: border-box;
        padding: 4px;
        border: 2px solid $color_purple;
        border-radius: 8px;
        &:focus {
          outline: none !important;
          box-shadow: 0 0 2px $color_purple;
        }
      }
    }
  }

  .calculator-description {
    margin-bottom: 32px;
    margin-top: 1 * $base_spacing;
  }

  .vue-slider {
    .vue-slider-process {
      background: $color_purple;
    }

    .vue-slider-dot-handle {
      background: $color_purple;
      border: 2px solid $color_purple;
    }

    &:hover .vue-slider-dot-handle {
      border-color: $color_purple;
    }

    .vue-slider-dot-tooltip-inner {
      font-size: 10px;
      padding: 4px;
    }

    .vue-slider-dot-tooltip-text {
      font-size: 10px;
      color: white;
    }
  }
}
</style>
